export default __webpack_public_path__ + "static/media/Single_Arrow_Black_Expand.1f1e1b58.svg";